import React from 'react';
import * as PropTypes from 'prop-types';

function CommonErrorLabel({ value, classNames }) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{value && <label className={`error-label ${classNames}`}>{value}</label>}</>;
}

CommonErrorLabel.defaultProps = {
  value: '',
  classNames: '',
};

CommonErrorLabel.propTypes = {
  value: PropTypes.string,
  classNames: PropTypes.string,
};

export default CommonErrorLabel;
